import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { awsServer, hostServer } from '../../../utilities/UrlPaths';

const InvaluableShippingBanner = () => {
  const [show, setShow] = useState(true);
  const closeBanner = () => setShow(false);
  return show ? (
    <Row>
      <Col xs={12} className="px-0">
        <div className="alert alert-info mt-3 alert-info-custom" role="alert">
          <div className="alert-content">
            <img src={`${awsServer}/static/invShippingIcon.png`} alt="shipping truck" className="shippingTruckIcon height-20" />
            <span className="pl-2 font-weight-bold">
              Invaluable Shipping
            </span>
            <div className="mt-2">
              Invaluable Shipping charges and customer support issues will be handled separately through Invaluable. <a href={`${hostServer}/inv/help-center/`} target="_blank" rel="noopener noreferrer" className="link-primary ml-1">Learn More</a>
            </div>
          </div>
          <button type="button" className="close modal-close-icon pb-5" onClick={closeBanner} aria-label="Close Invaluable Shipping banner">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </Col>
    </Row>
  ) : null;
};

export default InvaluableShippingBanner;
